import type { IClientConfig } from '$shared/interfaces/api/IClientConfig';
import type Parameter from '$shared/models/api/Parameter';
import { PathParamMetadataKey, QueryParamMetadataKey } from './constants';

const resolvePathParams = (target: unknown, propertyName: string, route: string, args: any) => {
  const pathParams: Array<Parameter> = Reflect.getOwnMetadata(
    PathParamMetadataKey,
    target,
    propertyName
  );
  if (!pathParams) {
    return route;
  }
  for (const pathParam of pathParams) {
    route = route.replace(`:${pathParam.key}`, args[pathParam.paramIndex]);
  }
  return route;
};

const resolveQueryParams = (target: unknown, propertyName: string, route: string, args: any) => {
  const queryParams: Array<Parameter> = Reflect.getOwnMetadata(
    QueryParamMetadataKey,
    target,
    propertyName
  );
  if (!queryParams) {
    return route;
  }
  let query = '';
  const queryObject = new URLSearchParams();
  for (const queryParam of queryParams) {
    const queryValue = args[queryParam.paramIndex];
    if (queryValue === null || queryValue === undefined) {
      continue;
    }

    // Support multiple value for a single param
    if (Array.isArray(queryValue)) {
      queryValue.forEach((val) => {
        query += `${query ? '&' : '?'}${queryParam.key}=${val}`;
      });
    } else if (queryValue && typeof queryValue === 'object') {
      Object.entries(queryValue).forEach(([key, value]) => {
        queryObject.set(`${queryParam.key}[${key}]`, value);
      });
    } else {
      queryObject.set(queryParam.key, queryValue);
    }
  }
  query += `${query ? '&' : '?'}${queryObject.toString()}`;
  if (query) {
    route += query;
  }
  return route;
};

const resolveRouteUrl = (
  target: unknown,
  propertyName: string,
  route: string,
  args: Record<string, any>,
  config: IClientConfig,
  baseUrl?: string
): string => {
  route = resolvePathParams(target, propertyName, route, args);
  route = resolveQueryParams(target, propertyName, route, args);
  return (baseUrl || config.baseUrl) + route;
};

export { resolveRouteUrl };
